import type { IconProps } from './IconProps';

export const InfoIconOutline = (props: IconProps) => (
  <svg
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 14}
    height={props.height ?? 14}
    {...props}
  >
    <g clipPath="url(#info-icon-outline-clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99984 12.1771C4.14061 12.1771 1.82275 9.85926 1.82275 7.00004C1.82275 4.14082 4.14061 1.82296 6.99984 1.82296C9.85906 1.82296 12.1769 4.14082 12.1769 7.00004C12.1769 9.85926 9.85906 12.1771 6.99984 12.1771ZM0.510254 7.00004C0.510254 10.5841 3.41574 13.4896 6.99984 13.4896C10.5839 13.4896 13.4894 10.5841 13.4894 7.00004C13.4894 3.41594 10.5839 0.510457 6.99984 0.510457C3.41574 0.510457 0.510254 3.41594 0.510254 7.00004ZM6.99984 9.98962C7.36227 9.98962 7.65609 9.69581 7.65609 9.33337V7.00004C7.65609 6.6376 7.36227 6.34379 6.99984 6.34379C6.6374 6.34379 6.34359 6.6376 6.34359 7.00004V9.33337C6.34359 9.69581 6.6374 9.98962 6.99984 9.98962ZM6.34359 4.66671C6.34359 5.02914 6.6374 5.32296 6.99984 5.32296H7.00567C7.36811 5.32296 7.66192 5.02914 7.66192 4.66671C7.66192 4.30427 7.36811 4.01046 7.00567 4.01046H6.99984C6.6374 4.01046 6.34359 4.30427 6.34359 4.66671Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="info-icon-outline-clip">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
